module.exports = __webpack_public_path__ + "static/media/Logo_v.8925dd8a.png";